<template>
	<el-dialog
		title="请选择验证方式"
		:visible.sync="dialogVisible"
		width="30%"
		:before-close="handleClose"
		:close-on-click-modal="false"
	>
		<div>
			<el-checkbox-group v-model="MFAs">
				<el-checkbox label="sms" :disabled="!userInfo.contactInfo" v-if="userInfo.brandSecverifyType.indexOf('sms')>-1">短信</el-checkbox>
				<el-checkbox label="email" :disabled="!userInfo.email" v-if="userInfo.brandSecverifyType.indexOf('email')>-1">邮件</el-checkbox>
			</el-checkbox-group>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	data() {
		return {
			dialogVisible: false,
			MFAs: [],
		};
	},
	computed: {
		...mapGetters(["userInfo"])
	},
	methods: {
		open(data) {
			this.bit = data.bit;
			this.key = data.key;
			this.dialogVisible = true;
			if (this.userInfo.secverifyType) {
				this.MFAs = this.userInfo.secverifyType.split(",");	
			}
		},
		submit() {
			this.$api
				.commonUpdateSecverifyType({
					bit: this.bit,
					key: this.key,
					types: this.MFAs,
				})
				.then((response) => {
					if (response.errcode != 0) return;
					if (response.data === true) {
						this.$store.dispatch("user/getInfo").then((response) => {});
						this.dialogVisible = false;
					}
				});
		},
		handleClose(done) {
			this.$confirm("确认关闭？")
				.then((_) => {
					done();
				})
				.catch((_) => {});
		},
	},
};
</script>

<style>
</style>